import axios, {
    AxiosError,
    AxiosInstance,
    AxiosRequestConfig,
    AxiosResponse,
} from "axios";
import {getRefreshToken, getToken, storeRefreshToken, storeToken} from "./token"
const API_URL = process.env.REACT_APP_BASE_API_URL;

const onRequest = (config: AxiosRequestConfig): AxiosRequestConfig => {
    const token = getToken()
    config.headers["Authorization"] = `Bearer ${token}`;

    return config;
};

const onRequestError = (error: AxiosError): Promise<AxiosError> => {
    return Promise.reject(error);
};

const onResponse = (response: AxiosResponse): AxiosResponse => {
    return response;
};

const onResponseError = async (error: AxiosError): Promise<AxiosError> => {
    if (error.response) {
        // Access Token was expired
        if (
            error.response.status === 401
        ) {
            const refreshToken = localStorage.getItem("refreshToken");

            try {
                const rs = await axios.post(`${API_URL}auth/refresh`, {
                    refreshToken: refreshToken,
                });

                let token = rs.data.token;
                let newRefreshToken = rs.data.refreshToken;

                storeToken(token);
                storeRefreshToken(newRefreshToken);

                return;
            } catch (_error) {
                return Promise.reject(_error);
            }
        }
    }
    return Promise.reject(error);
};

export const setupInterceptorsTo = (
    axiosInstance: AxiosInstance
): AxiosInstance => {
    axiosInstance.interceptors.request.use(onRequest, onRequestError);
    axiosInstance.interceptors.response.use(onResponse, onResponseError);
    return axiosInstance;
};
